import { isEqual, get, flow, toPairs, filter, map, fromPairs, constant, pick, curry, find } from 'lodash/fp';

const isDifferent = (a, b) => !isEqual(a, b);

const normalizedValueIsDifferent = (attribute, newValue) => isDifferent(
  get('normalizedValue', attribute),
  newValue,
);

const normalizedWriter = (attribute, newValue) => flow(
  pick(['displayName', 'sortIndex', 'displayPriority']),
  attr => ({
    ...attr,
    value: newValue,
    normalizedValue: newValue,
  }),
  JSON.stringify,
)(attribute);

export const editableAttributes = {
  width: {
    shouldUpdate: normalizedValueIsDifferent,
    valueWriter: normalizedWriter,
  },
  height: {
    shouldUpdate: normalizedValueIsDifferent,
    valueWriter: normalizedWriter,
  },
  depth: {
    shouldUpdate: normalizedValueIsDifferent,
    valueWriter: normalizedWriter,
  },
  category: {
    shouldUpdate: normalizedValueIsDifferent,
    valueWriter: normalizedWriter,
  },
  mountType: {
    shouldUpdate: normalizedValueIsDifferent,
    valueWriter: normalizedWriter,
  },
  purchaseOption: {
    shouldUpdate: attr => isDifferent(
      get('value', attr),
      '',
    ),
    valueWriter: constant(''),
  },
};

const getAttribute = curry((name, attrs) => find({ name }, attrs));

const getChangedAttributes = (data, attributes) => flow(
  toPairs,
  filter(([key, { shouldUpdate }]) => shouldUpdate(
    getAttribute(key, attributes),
    get(key, data),
  )),
  map(([key, { valueWriter }]) => [
    key,
    {
      attributeId: flow(
        getAttribute(key),
        get('attributeId'),
      )(attributes),
      newValue: valueWriter(
        getAttribute(key, attributes),
        get(key, data),
      ),
    },
  ]),
  fromPairs,
)(editableAttributes);

export default getChangedAttributes;
